/**
 * ModalProvider - Provider para gerenciamento de modals
 */
import React, { useState, ReactNode, useCallback } from 'react';
import { ModalAlerta, TipoModalAlerta } from '../componentes/comuns/ModalAlerta';
import { ModalContext, ESTADO_INICIAL_MODAL, OpcoesAlerta, OpcoesConfirmacao, ContextoModal } from './modalContext';

interface EstadoModal {
  estaVisivel: boolean;
  titulo: string;
  mensagem: string;
  tipo: TipoModalAlerta;
  aoConfirmar: () => void;
  aoCancelar?: () => void;
  textoConfirmar?: string;
  textoCancelar?: string;
}

interface PropriedadesModalProvider {
  children: ReactNode;
}

export function ModalProvider({ children }: PropriedadesModalProvider): JSX.Element {
  const [estadoModal, setEstadoModal] = useState<EstadoModal>(ESTADO_INICIAL_MODAL);

  const fecharModal = useCallback(() => {
    setEstadoModal(ESTADO_INICIAL_MODAL);
  }, []);

  const mostrarAlerta = useCallback((opcoes: OpcoesAlerta) => {
    setEstadoModal({
      estaVisivel: true,
      titulo: opcoes.titulo,
      mensagem: opcoes.mensagem,
      tipo: 'alerta',
      aoConfirmar: () => {
        if (opcoes.aoConfirmar) opcoes.aoConfirmar();
        fecharModal();
      },
      textoConfirmar: opcoes.textoConfirmar,
    });
  }, [fecharModal]);

  const mostrarConfirmacao = useCallback((opcoes: OpcoesConfirmacao) => {
    setEstadoModal({
      estaVisivel: true,
      titulo: opcoes.titulo,
      mensagem: opcoes.mensagem,
      tipo: 'confirmacao',
      aoConfirmar: () => { opcoes.aoConfirmar(); fecharModal(); },
      aoCancelar: () => { if (opcoes.aoCancelar) opcoes.aoCancelar(); fecharModal(); },
      textoConfirmar: opcoes.textoConfirmar,
      textoCancelar: opcoes.textoCancelar,
    });
  }, [fecharModal]);

  const valorContexto: ContextoModal = {
    mostrarAlerta,
    mostrarConfirmacao,
    fecharModal,
  };

  return (
    <ModalContext.Provider value={valorContexto}>
      {children}
      <ModalAlerta
        estaVisivel={estadoModal.estaVisivel}
        titulo={estadoModal.titulo}
        mensagem={estadoModal.mensagem}
        tipo={estadoModal.tipo}
        aoConfirmar={estadoModal.aoConfirmar}
        aoCancelar={estadoModal.aoCancelar}
        textoConfirmar={estadoModal.textoConfirmar}
        textoCancelar={estadoModal.textoCancelar}
      />
    </ModalContext.Provider>
  );
}
